var _rect, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 40,
    height: 32,
    rx: 4,
    stroke: "#141718",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 20 28)",
    stroke: "#141718",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 34 26)",
    fill: "#141718"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 10 26)",
    fill: "#141718"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.ef40beb8e1d4707c770e831c827e5903.svg";
export { ForwardRef as ReactComponent };